import Applications from './Applications';
import Home from './Home';
import Keys from './Keys';
import Landing, { Unauthorized } from './Landing';
import Reports from './Reports';
import Team from './Team';
import Teams from './Teams';
import TeamRoles from './TeamRoles';
import DevLandingPage from './DevLandingPage';
import Roles from './Roles';

export { default as Applications } from './Applications';
export { default as Home } from './Home';
export { default as Landing, Unauthorized } from './Landing';
export { default as Reports } from './Reports';
export { default as Team } from './Team';
export { default as Teams } from './Teams';
export { default as TeamRoles } from './TeamRoles';
export { default as DevLandingPage } from './DevLandingPage';
export { default as Roles } from './Roles';

export default {
  Applications,
  Home,
  Keys,
  Landing,
  Unauthorized,
  Reports,
  Team,
  Teams,
  TeamRoles,
  DevLandingPage,
  Roles,
};
